import avatar from "../assets/avatar.png";

export const TESTIMONIALS = [
  {
    id: 1,
    photo: avatar,
    name: 'John',
    rating: 5,
    review: 'I love the greek salad.',
  },
  {
    id: 2,
    photo: avatar,
    name: 'Jenny',
    rating: 5,
    review: 'Best greek salad in chicago.',
  },
  {
    id: 3,
    photo: avatar,
    name: 'Will Smith',
    rating: 2,
    review: 'I`ve had better greek salads...',
  },
  {
    id: 4,
    photo: avatar,
    name: 'Madonna',
    rating: 5,
    review: 'Can`t get enough of the greek salad :D',
  },
];